// Chat-specific icons (User and Assistant)
import React from 'react';

export const UserIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{verticalAlign: 'middle', marginRight: 4}}>
    <circle cx="12" cy="8" r="4" fill="#2563eb" stroke="#fff" strokeWidth="2"/>
    <path d="M4 20c0-3.5 3.5-6 8-6s8 2.5 8 6" fill="#60a5fa" stroke="#fff" strokeWidth="2"/>
  </svg>
);

// Modern assistant icon (robot head)
export const AssistantIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{verticalAlign: 'middle', marginRight: 4}}>
    <rect x="4" y="8" width="16" height="8" rx="4" fill="#2ec4b6"/>
    <rect x="7" y="6" width="10" height="6" rx="3" fill="#5eead4"/>
    <circle cx="9" cy="12" r="1" fill="#22223b"/>
    <circle cx="15" cy="12" r="1" fill="#22223b"/>
    <rect x="11" y="14" width="2" height="1" rx="0.5" fill="#22223b"/>
    <rect x="10" y="4" width="4" height="2" rx="1" fill="#2ec4b6"/>
  </svg>
);
